import { Box } from 'styled-system/jsx';
import { useController, useFormContext } from 'react-hook-form';
import { CheckBoxType } from '@/common/components/base/checkBox/CheckBox.type.ts';
import BaseCheckBox from '@/common/components/BaseCheckbox/BaseCheckBox';

const CheckBox = ({
  name,
  defaultValue,
  onChange,
  disabled = false,
  id,
}: CheckBoxType) => {
  const { control } = useFormContext();
  const { field } = useController({
    control,
    name,
    defaultValue,
  });
  return (
    <Box
      onClick={(event) => {
        field.onChange(!field.value);
        onChange?.(!field.value);
        event.stopPropagation();
      }}
      position="relative"
      width="16px"
      height="16px"
    >
      <BaseCheckBox
        id={id}
        disabled={disabled}
        checked={Boolean(field.value)}
      />
    </Box>
  );
};
export default CheckBox;
